import { getRequestAction } from 'helpers/functions';

const ACTION_PREFIX = 'files';

export const getFile = getRequestAction(`${ACTION_PREFIX}/getFile`);
